module.exports = __webpack_public_path__ + "0cfacfbdd0d7f0072a69d05085875469.woff";